import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import useFetch from '../Utilities/useFetch';
import 'bootstrap/dist/css/bootstrap.min.css';


const ReportTemplateDateNoClick = ({
    columnDefs,
    apiUrl,
    reportName
}) => {
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with today's date
    const [rowData, setRowData] = useState([]);
    // I fixed the format you had for the fetch call
    // I left your old code commented out so you could see the difference
    // const { data, error } =  useFetch(true, `${apiUrl}?reportDate=${date}`, 'GET');
    const { data, error } =  useFetch(true, apiUrl, 'GET', null, {reportDate:date});


    // I wrapped this if statement in a useEffect so react can keep better track of the state
    useEffect(()=>{
        if (error) {
            setRowData([]); // Clear data if the response is not OK
            console.error('Error fetching data:'+{date}, error);
        }
    // because error is in this array, this will only run if error changes
    // eslint-disable-next-line
    },[error]);

    useEffect(() => {
        if (data) {
            setRowData(data);
        }
    }, [data]);
   
     const handleDateChange = (newDate) => {
        setDate(newDate);
    };

    // Not best practice to have code outside of useEffects, this code is already in a useEffect on line 26
    // if (error) {
    //     console.error('Error fetching data:', error);
    // }
 
 
    // I'm not sure the advantage of this component, but I left it as is
    // You could simply put the input in the ReportTemplateDateNoClick return statement
    const DatePicker = ({ value }) => {
        return (
            <input
                type="date"
                value={value}
                onChange={(e) =>  handleDateChange(e.target.value)}
            />
        );
    };

    return (
        <div>
            <h4 className='margin'>{reportName}</h4>
            <div className="date-picker">
                <label htmlFor="report-date">Select Report Date: &nbsp;</label>
                <DatePicker value={date} /> 
                <span> &nbsp; Row Count: {rowData.length}</span>
            </div>
                {error && <div className="error-message">Error fetching data: {error.message}</div>}
            <div className="ag-theme-quartz compact-theme grid">
                
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true }}
                    onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                />
            </div>
         </div>
    );
};

export default ReportTemplateDateNoClick;